import React, { useState, useEffect, useContext } from "react";
import { withRouter } from "react-router-dom";
import { Typography, InputNumber, Button, Table, message, Tabs } from "antd";
import { platformApi } from "../../../../api";
import { ContextAPI } from "../../../../ContextAPI";

const { Title } = Typography;
const { TabPane } = Tabs;

const denominationsList = [500, 200, 100, 50, 20, 10, 5, 2, 1];

const DenominationInventory = () => {
  const [denominations, setDenominations] = useState(
    denominationsList.map((d) => ({ denomination: d, count: 0 }))
  );
  const { loginCredintials } = useContext(ContextAPI);
  const [saving, setSaving] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [activeBranch, setActiveBranch] = useState(null); 
  const [modifyAccess, setModifyAccess] = useState(false);

  useEffect(() => {
    if (branches.length > 0) {
      const firstBranch = branches[0];
      setActiveBranch(firstBranch);
      getDenominationInventory(firstBranch.id);
    }
  }, []);

  useEffect(() => {
    loginCredintials.roleAccess &&
      loginCredintials.roleAccess.map((each) => {
        if (each.subModule === "denomination_inventory") {
          if (each.access.update) {
            setModifyAccess(true);
          }
        }
      });
  }, []);

  const branches = JSON.parse(localStorage.getItem("branch")) || [];

  const getDenominationInventory = (branchId) => {
    if (!branchId) return;
    platformApi
      .post(`/api/payment/denominationInventory`, { branch: [branchId] })
      .then((res) => {
        const { data } = res;
        if (data.code === 200 && data.response.code === 200) {
          const fetchedRecords = data.response.data[0]?.denominations || [];

          // Map fetched records to denominations
          const newDenominations = denominationsList.map((denom) => {
            const record = fetchedRecords.find((r) => r.denomination === denom);
            return {
              denomination: denom,
              count: record ? record.count : 0,
            };
          });

          setDenominations(newDenominations);
          setDataSource(fetchedRecords); // saved records
        } else {
          message.error("Failed to fetch denomination records");
        }
      })
      .catch((err) => {
        console.error("Fetch Error:", err);
        message.error("Error fetching denomination inventory");
      });
  };

  // Calculate total value
  const totalValue = denominations.reduce(
    (sum, d) => sum + d.denomination * (d.count || 0),
    0
  );

  // Save denominations for the active branch
  const handleSave = () => {
    if (!activeBranch) {
      message.error("Select a branch before saving");
      return;
    }

    setSaving(true);

    platformApi
      .post("/api/payment/denominationInventory/create", {
        branch: { id: activeBranch.id },
        denominations,
        totalValue,
      })
      .then((res) => {
        const { data } = res;
        if (data.code === 200 && data.response.code === 200) {
          message.success("Denomination inventory saved successfully");
          getDenominationInventory(activeBranch.id);
        } else {
          message.error("Failed to save denomination data");
        }
      })
      .catch((err) => {
        console.error("Save Error:", err);
        message.error("Error saving denomination data");
      })
      .finally(() => setSaving(false));
  };

  // Called when user switches tabs
  const handleTabChange = (key) => {
    const selectedBranch = branches.find((b) => b.id === key);
    setActiveBranch(selectedBranch);
    // Reset denominations or fetch existing ones
    getDenominationInventory(key);
  };

  const columns = [
    {
      title: "Denomination",
      dataIndex: "denomination",
      key: "denomination",
      render: (text) => `₹${text}`,
    },
    {
      title: "Count",
      dataIndex: "count",
      key: "count",
      render: (text, record, index) => (
        <InputNumber
          min={0}
          value={record.count}
          onChange={(value) => {
            const newDenoms = [...denominations];
            newDenoms[index].count = value || 0;
            setDenominations(newDenoms);
          }}
        />
      ),
    },
    {
      title: "Total",
      key: "total",
      render: (_, record) => `₹${record.denomination * record.count}`,
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <div className="inventory-header">
        <Title level={4}>Denomination Inventory</Title>
      </div>

      <Tabs defaultActiveKey={branches[0]?.id} onChange={handleTabChange}>
        {branches.map((branch) => (
          <TabPane tab={branch.name} key={branch.id}>
            <Table
              columns={columns}
              dataSource={denominations}
              pagination={false}
              rowKey={(record) => record.denomination}
            />

            <div style={{ marginTop: "20px", textAlign: "right" }}>
              <h3>Total Value: ₹{totalValue}</h3>
              <Button
                type="primary"
                onClick={handleSave}
                loading={saving}
                style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}
                disabled={!modifyAccess}
              >
                Save Denominations
              </Button>
            </div>
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default withRouter(DenominationInventory);
